import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITerminalProfileResolverService = ( createDecorator('terminalProfileResolverService'));
const ITerminalProfileService = ( createDecorator('terminalProfileService'));
export { ITerminalProfileResolverService, ITerminalProfileService };
